import React from 'react';

export const Empty = () => {
	return (
		<div className='my-4 mt-8 text-lg font-bold text-center text-gray-400'>
			This is quite empty...
		</div>
	);
};
